export default "__VITE_ASSET__BIp0EQAX__"